import Login from '@/pages/Login.vue'
import Register from '@/pages/Register.vue'
import Home from '@/pages/Home.vue'
import TwoFA from '@/pages/2FA.vue'
import Landing from '@/pages/Landing.vue'
import Logout from '@/pages/Logout.vue'
import PageNotFound from '@/pages/PageNotFound.vue'
import AvailableSurveys from '@/pages/Admin/Surveys/AvailableSurveys.vue'
import Analytics from '@/pages/Analytics.vue'
import BaladyAnalytics from '@/pages/BaladyAnalytics.vue'
import SakaniAnalytics from '@/pages/SakaniAnalytics.vue'
import ExecutiveAnalytics from '@/pages/ExecutiveAnalytics.vue'
import Insights from '@/pages/Insights.vue'
import Dashboard from '@/pages/Dashboard.vue'

export default [
	{
		name: 'landing',
		path: '/',
		component: Landing,
	},
	{
		name: 'home',
		path: '/',
		component: Home,
		meta: {
			secure: true
		}
	},
	{
		name: '2FA',
		path: '/2FA',
		component: TwoFA,
		meta: {
			secure: false
		}
	},
	{
		name: 'login',
		path: '/login',
		component: Login
	},
	{
		name: 'analytics',
		path: '/analytics',
		component: Analytics
	},
	{
		name: 'insights',
		path: '/insights',
		component: Insights
	},
	
	{
		name: 'balady-analytics',
		path: '/balady-analytics',
		component: BaladyAnalytics
	},
	{
		name: 'sakani-analytics',
		path: '/sakani-analytics',
		component: SakaniAnalytics
	},
	{
		name: 'executive-analytics',
		path: '/executive-analytics',
		component: ExecutiveAnalytics,
		meta: {
			secure: true
		}
	},
	// executive dashboard: every tab is its own route on the same page component
	{
		name: 'dashboard',
		path: '/dashboard',
		component: Dashboard,
		meta: {
			secure: true,
			fullPage: true
		}
	},
	{
		name: 'dashboard-indicators',
		path: '/dashboard/indicators',
		component: Dashboard,
		meta: {
			secure: true,
			fullPage: true
		}
	},
	{
		name: 'dashboard-surveys',
		path: '/dashboard/surveys',
		component: Dashboard,
		meta: {
			secure: true,
			fullPage: true
		}
	},
	{
		name: 'dashboard-survey',
		path: '/dashboard/surveys/:id',
		component: Dashboard,
		meta: {
			secure: true,
			fullPage: true
		}
	},
	{
		name: 'dashboard-strategic',
		path: '/dashboard/strategic',
		component: Dashboard,
		meta: {
			secure: true,
			fullPage: true
		}
	},
	{
		name: 'dashboard-compare',
		path: '/dashboard/compare',
		component: Dashboard,
		meta: {
			secure: true,
			fullPage: true
		}
	},
	{
		name: 'available-Surveys',
		path: '/available-Surveys',
		component: AvailableSurveys
	},
	{
		name: 'logout',
		path: '/logout',
		component: Logout,
		meta: {
			secure: true
		}
	},
	{
		name: 'register',
		path: '/register',
		component: Register
	},
	{
		name: 'not-found',
		path: '/:pathMatch(.*)*',
		component: PageNotFound
	},
]